import React from 'react';

const EquipmentsTab = ({ selected, equipments }) => {
  if (!equipments) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`}>
      <h2>{equipments.title}</h2>
      <ul>
        {equipments.data.map((equipment, index) => (
          <li key={index}>{equipment.value}</li>
        ))}
      </ul>
    </div>
  );
};

export default EquipmentsTab;
